import { CSSProperties, ReactNode } from 'react';
import { useNarrow } from '../../../lib/use-narrow';
import { CatchUpSections } from '../catch-up';
import { HomeHeader } from './HomeHeader';

export function DashboardPane({
  children,
  scroll = false,
  bare = false,
}: {
  children: ReactNode;
  scroll?: boolean;
  // The empty home takes over the whole pane — no greeting, no catch-up band — so the
  // "One home for everything" intro sits alone, matching Figma `10941:75527` (the same
  // way the empty Your-Agents screen drops its page title).
  bare?: boolean;
}) {
  const narrow = useNarrow();
  return (
    <section
      className="orion-content-pane"
      style={{
        ...styles.pane,
        // Narrow home: the greeting/date top-aligns with the hamburger (Figma
        // 6393-24243), so the top inset matches the hamburger's ~24px offset
        // instead of the 96px band other mobile pages use.
        paddingBlock: narrow ? '24px 40px' : '72px 40px',
        // The empty home's conveyor bleeds to the region's edges, so drop the 80px
        // page gutter `.orion-content-pane` adds — the centered intro keeps its
        // midpoint, only the full-width band reaches the edges.
        ...(bare ? { paddingInline: 0 } : null),
        overflowY: scroll ? 'auto' : 'hidden',
      }}
    >
      {!bare && <HomeHeader />}
      {!bare && <CatchUpSections />}
      {scroll ? <div style={styles.scrollChild}>{children}</div> : <div style={styles.fillChild}>{children}</div>}
    </section>
  );
}

const styles: Record<string, CSSProperties> = {
  pane: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    zIndex: 4,
    overflowX: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  scrollChild: { position: 'relative', width: '100%', flexShrink: 0 },
  fillChild: { flex: 1, minHeight: 0, position: 'relative' },
};
